/**
 * DiscountDetailsModalCtrl controller
 *
 * @class DiscountDetailsModalCtrl
 * @memberof mwApp/packages
 * @see mwApp/packages
 *
 * @ngdoc controller
 * @name mwApp/packages.controller:SubscriptionDiscountCampaignErrorModalCtr
 */

/* @ngInject */
export default function DiscountDetailsModalCtrl ($uibModalInstance, storageSvc, item, purchaseNumber) {
  const vm = this
  vm.item = item
  vm.purchaseNumber = purchaseNumber

  if (storageSvc.local.get('currencies')) {
    vm.currencies = JSON.parse(storageSvc.local.get('currencies'))
  } else {
    vm.currencies = []
  }

  vm.getCurrencyByCode = function (code) {
    return vm.currencies.find(c => c.name === code)
  }
  vm.dismiss = $uibModalInstance.dismiss
}
